import { makeStyles } from '@material-ui/core/styles';
import { Theme as DefaultTheme } from '@material-ui/core/styles/createMuiTheme';

export const useStyles = makeStyles<DefaultTheme, { isMobile?: boolean | undefined }>(theme => ({
    container: {
        flexDirection: props => (props.isMobile ? 'column' : 'row'),
        justifyContent: props => (props.isMobile ? 'start' : 'center'),
        padding: props => (props.isMobile ? '0px' : undefined),
        paddingBottom: props => (props.isMobile ? theme.spacing(2) : undefined),
    },
    menuItem: {
        paddingLeft: props => (props.isMobile ? theme.spacing(0) : theme.spacing(4)),
        paddingRight: props => (props.isMobile ? theme.spacing(0) : theme.spacing(4)),
        paddingTop: props => (props.isMobile ? theme.spacing(2) : theme.spacing(0)),
    },
    link: {
        textAlign: props => (props.isMobile ? 'start' : undefined),
        marginBottom: props => (props.isMobile ? '12px' : undefined),
        color: '#7a7883',
        textDecoration: 'none',
        '&:hover': {
            color: theme.palette.primary.main,
        },
    },
    activeLink: {
        color: theme.palette.primary.main,
    },
    linkText: {
        fontSize: 18,
        fontWeight: 400,
    },
    icon: {
        width: '1.25em !important',
        height: '1.25em !important',
    },
}));
